module.exports = __webpack_public_path__ + "static/img/isTip.c0c0314.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/isTip.png
// module id = 4Hfv
// module chunks = 0